/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ToolsIcon = ({ width = 24, height = 24, hidden = false, title = 'Tools' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M8.74707,5.3291l-1.82031-3.50391c-.16992-.33105-.50781-.53809-.87988-.54102h-.00781c-.36914,0-.70605.20215-.87988.52539l-1.88965,3.50098c-.17578.32715-.26953.69629-.26953,1.06836v10.37109c0,1.24023,1.00977,2.25,2.25,2.25h1.5c1.24023,0,2.25-1.00977,2.25-2.25V6.36621c0-.36035-.08789-.71875-.25293-1.03711ZM7.5,7.5v7h-3v-7h3ZM6.03027,3.35352l1.37451,2.64648h-2.80225l1.42773-2.64648ZM6.75,17.5h-1.5c-.41309,0-.75-.33691-.75-.75v-.75h3v.75c0,.41309-.33691.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M14.75,1h-1.5c-1.24023,0-2.25,1.00977-2.25,2.25v6.729c0,.00488-.00293.00903-.00293.01416,0,.00537.00293.00952.00293.01489v3.72192c0,.00488-.00293.0083-.00293.01318,0,.00537.00293.00952.00293.01489v2.99194c0,1.24023,1.00977,2.25,2.25,2.25h1.5c1.24023,0,2.25-1.00977,2.25-2.25V3.25c0-1.24023-1.00977-2.25-2.25-2.25ZM15.5,16.75c0,.41309-.33691.75-.75.75h-1.5c-.41309,0-.75-.33691-.75-.75v-2.25098l1.24414.00488h.00293c.41309,0,.74805-.33398.75-.74707.00195-.41406-.33301-.75098-.74707-.75293l-1.25-.00488v-2.25l1.24414.00488h.00293c.41309,0,.74805-.33398.75-.74707.00195-.41406-.33301-.75098-.74707-.75293l-1.25-.00488v-2.24561l1.24707.00537h.00293c.41309,0,.74805-.33398.75-.74707.00195-.41406-.33203-.75098-.74707-.75293l-1.25293-.00537v-2.25342c0-.41309.33691-.75.75-.75h1.5c.41309,0,.75.33691.75.75v13.5Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
